import { render, staticRenderFns } from "./pop_up_copy.vue?vue&type=template&id=00465fd0&scoped=true&lang=pug&"
import script from "./pop_up_copy.vue?vue&type=script&lang=js&"
export * from "./pop_up_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00465fd0",
  null
  
)

export default component.exports